import { NgModule } from '@angular/core';
import { IsValidBisnodeStatusPipe } from './bisnode-status.pipe';

@NgModule({
  declarations: [IsValidBisnodeStatusPipe],
  exports: [IsValidBisnodeStatusPipe],
})
export class IsValidBisnodeStatusPipeModule {}
